import { formDefinition } from '@social-solutions/ssg-forms-processing';

/**
 * Details of the read only form to show after the user
 * has submitted an answer for the "unsubscribe?" question.
 */

export const confirmedMessageInstructionElement = {
  id: 'confirmed-message-instruction-element',
  label: 'Your selection has been confirmed. You may close this browser window.',
  ariaLabel: "Your selection has been confirmed. You may close this browser window.",
  type: formDefinition.elementTypes.heading,
};

const confirmedFormDef = {
  id: 'confirmed-form',
  name: null,
  elements: [confirmedMessageInstructionElement]
}

export default confirmedFormDef;



// WEBPACK FOOTER //
// src/acct/opt-out/confirmed-form-definition.js